module.exports = __webpack_public_path__ + "static/media/AssaultCuirass.e936e954.png";